export const WORKSHOP_MODULE_CONTENT_CONFIG = {
  defaultModuleKey: 'pre-workshop',
  modules: {
    'pre-workshop': {
      lessons: {
        'introduction': {
          survey: {
            surveyid: 4,
            title: 'Pre-Workshop Readiness Check',
            description: 'Help us understand your preparation level before the workshop begins.',
          },
        },
        'pre-requisites': {
          survey: null,
        },
      },
      metadata: {
        heading: '',
        description: '',
        sections: [
           
        ],
      },
      backend: {
   
      },
    },

    'workshop-day': {
      metadata: {
        heading: 'Workshop-Day Metadata',
        description: 'Execution phase where participants apply concepts and iterate rapidly.',
        sections: [
          {
            id: 'purpose',
            title: 'Purpose',
            type: 'text',
            value: 'Convert workshop learning into actionable solutions during live facilitation.',
          },
          {
            id: 'activities',
            title: 'Core Activities',
            type: 'list',
            items: ['Case study framing', 'Prompt labs', 'Collaborative solution shaping'],
          },
        ],
      },
      backend: {
        endpoint: '/workshops/workbench/scenarios',
        queryKeys: ['eventid', 'attendeeid', 'isactive'],
        responsePath: 'data[0]',
        emptyState: 'No workshop-day data available yet.',
        fields: [
          { key: 'title', label: 'Case Study Title' },
          { key: 'personas', label: 'Personas' },
          { key: 'rules', label: 'Rules & Constraints' },
          { key: 'acceptance_criteria', label: 'Acceptance Criteria' },
        ],
      },
    },

    'post-workshop': {
      lessons: {
        'workshop-feedback': {
          survey: {
            surveyid: 4,
            title: 'Workshop Feedback',
            description: 'Share your experience and help us improve future workshops.',
          },
        },
      },
      metadata: {
        heading: 'Post-Workshop Metadata',
        description: 'Reinforcement phase to convert outcomes into sustained implementation.',
        sections: [
          {
            id: 'purpose',
            title: 'Purpose',
            type: 'text',
            value: 'Capture insights and define the next implementation cycle after the workshop.',
          },
          {
            id: 'outcomes',
            title: 'Expected Outcomes',
            type: 'list',
            items: ['Knowledge retention', 'Action plan ownership', 'Execution follow-up'],
          },
        ],
      },
      backend: {
        endpoint: '/workshops/workbench/scenarios',
        queryKeys: ['eventid', 'attendeeid', 'isactive'],
        responsePath: 'data[0]',
        emptyState: 'No post-workshop backend data available yet.',
        fields: [
          { key: 'description', label: 'Summary' },
          { key: 'business_problem', label: 'Business Problem Recap' },
        ],
      },
    },
  },
};
